export const orderModels = [
  {
    name: 'order',
    fields: [
      'additionalNotes',
      'applyDeliveryFee',
      'authorizationCode',
      'createdAt',
      'deliveryBuilding',
      'deliveryFee',
      'deliveryNotes',
      'deliveryRoom',
      'discount',
      'fulfillment',
      'fulfillmentAddress',
      'fulfillmentDate',
      'fulfillmentLocationId',
      'fulfillmentLocationName',
      'fulfillmentTime',
      'id',
      'location',
      'no',
      'paymentType',
      'pnref',
      'promoCode',
      'promotion',
      'response',
      'result',
      'shipping',
      'shippingFee',
      'subscriptionPayment',
      'subtotal',
      'tax',
      'total',
    ],
    relationships: {
      shoppingCart: { jsonApi: 'hasOne', type: 'shoppingCart' },
      customer: { jsonApi: 'hasOne', type: 'customer' },
      site: { jsonApi: 'hasOne', type: 'site' },
      items: { jsonApi: 'hasMany', type: 'orderItem' },
    },
  },
  {
    name: 'orderItem',
    fields: [
      'applyTax',
      'description',
      'id',
      'itemImage',
      'name',
      'options',
      'price',
      'qty',
      'registered',
      'shopItemId',
      'subscription',
      'subscriptionDuration',
      'subscriptionEnd',
      'subscriptionStart',
      'tax',
      'taxRate',
    ],
    relationships: { order: { jsonApi: 'hasOne', type: 'order' } },
  },
]
